export default __webpack_public_path__ + "static/media/gallery-wip-construction-improvements-screw-replacement_03.9e1b312a.jpg";